import '../scss/style.scss';

window.$ = window.jQuery = require('jquery');

import { createPopper } from '@popperjs/core';
import { Tooltip } from 'bootstrap/dist/js/bootstrap';

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));

require('./libs/css3-animate-it');
require('./libs/scrollbar');
require('./libs/slick');

require('./animated');
require('./fixed-height');
require('./smooth-scroll');
require('./featured-products');
require('./history-nav');
require('./history-slider');
require('./sales-points-map');